<template>
  <div>
    <h2>{{heading}}</h2>
    <p>{{content}}</p>
  </div>
</template>

<script>
export default {
  name: 'intro-block',
  props: {
    heading: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../assets/variables';

h2 {
  color: $brand-white;
  font-family: 'EffraBold';
  font-size: 30px;
  border-bottom: 4px solid $brand-primary;
  padding: 0 0 5px;
  display: inline-block;
  text-transform: uppercase;
}

p {
  color: $brand-white;
  font-family: 'OpenSans';
  font-size: 14px;
  line-height: 1.4;
  margin: 0 0 30px;
}

@media #{$breakpoint-md} {
  p {
    min-height: 135px;
    margin: 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IntroBlock.vue